import {Color, Font} from '~/constants/style';

export const mobileStyles = {
  processLoading: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: Color.Grey100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  },
  mobileContainer: {
    width: '100%',
    maxWidth: '100%',
    padding: {
      xs: '0.5rem',
      sm: '1rem',
      md: '2rem',
      lg: '3rem',
    },
    margin: '0 auto',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '464px',
    margin: '0 auto',
    padding: {
      xs: '0',
      sm: '0',
    },
  },
};

export const paymentLinkStyles = {
  container: {
    width: '100%',
    minHeight: {
      xs: 'calc(100vh - 80px)',
      sm: '100vh',
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflowY: 'auto',
    position: 'relative',
  },
  stack: {
    width: '100%',
    maxWidth: '464px',
    alignItems: 'center',
  },
  headerBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
    gap: 1,
    width: '100%',
    maxWidth: '464px',
  },

  footerBox: {
    width: '100%',

    margin: '0',
    mt: 2,
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '200px',
    width: '100%',
  },
  loadingText: {
    mt: 2,
    textAlign: 'center',
  },
  paymentSummaryBox: {
    width: '100%',
    margin: '0',
  },
  stripeWidget: {
    width: '100%',
    margin: '0',
  },
};

import {SxProps, Theme} from '@mui/material/styles';

export const bookingPaymentSummaryStyles = {
  mainContainer: {
    minHeight: '100vh',
    padding: {xs: 2, sm: 3, md: 4},
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingTop: {xs: 4, sm: 6, md: 8},
  } as SxProps<Theme>,

  paymentCard: {
    borderRadius: 3,
    padding: {xs: 3, sm: 4, md: 5},
    maxWidth: {xs: '100%', sm: 500, md: 600},
    width: '100%',

    position: 'relative',
  } as SxProps<Theme>,

  headerSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 4,
  },

  stoneygateText: {
    fontSize: {xs: 10, sm: 11, md: 12},
    color: '#666',
    lineHeight: 1.2,
  },

  paymentTitle: {
    fontFamily: Font.Lexend,
    fontWeight: 600,
    color: Color.PrimaryMain,
    fontStyle: 'normal',
    fontSize: '32px',
    lineHeight: '36px',
    letterSpacing: '-0.24px',
  },

  descriptionText: {
    mt: 2,
    fontFamily: Font.Lexend,
    color: Color.TextTertiary,
    fontWeight: 300,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '18px',
    letterSpacing: '-0.11px',
  },

  contactLink: {
    color: Color.PrimaryMain,
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: '#7b1fa2',
    },
  },

  discoverButton: {
    px: '24px',
    py: '12px',
    backgroundColor: Color.WarningMain,
    fontFamily: Font.Lexend,
    color: Color.White,
    borderRadius: '8px',
    size: '18px',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '18px',
    lineHeight: '22px',
    letterSpacing: '-0.14px',
    textTransform: 'none',
  },

  summarySection: {
    marginTop: 4,
  },

  summaryTitle: {
    fontSize: '24px',
    lineHeight: '28px',
    fontWeight: 600,
    color: Color.PrimaryMain,
    marginBottom: 3,
  },

  totalAmount: {
    fontSize: {xs: 36, sm: 42, md: 48},
    fontWeight: 'bold',
    marginBottom: 3,
  },

  paymentBreakdown: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 1,
  },

  breakdownLabel: {
    fontSize: {xs: 13, sm: 14, md: 15},
    opacity: 0.9,
  },

  breakdownAmount: {
    fontSize: {xs: 13, sm: 14, md: 15},
    fontWeight: '500',
  },

  appointmentSection: {
    marginTop: 4,
    backgroundColor: 'transparent',
    maxWidth: 460,
  },

  appointmentRow: {
    display: 'flex',
    flexDirection: {xs: 'column', sm: 'row'},
    justifyContent: 'space-between',
    alignItems: {xs: 'flex-start', sm: 'center'},
    marginBottom: 1,
    gap: {xs: 0.5, sm: 0},
  },

  appointmentLabel: {
    color: Color.PrimaryMain,
    fontFamily: Font.Lexend,
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '16px',
    lineHeight: '22px',
    letterSpacing: '-0.12px',
    verticalAlign: 'bottom',
  },

  appointmentValue: {
    fontFamily: Font.Lexend,
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '-0.11px',
    verticalAlign: 'bottom',
  },

  footerWebsite: {
    textAlign: 'center',
    marginTop: 4,
    fontSize: {xs: 11, sm: 12},
    color: '#999',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.5,
  },

  lockIcon: {
    fontSize: 14,
    color: '#999',
  },

  hideOnMobile: {
    display: {xs: 'none', sm: 'block'},
  },

  showOnMobile: {
    display: {xs: 'block', sm: 'none'},
  },

  contentStack: {
    spacing: {xs: 2, sm: 3},
  },
};

export const bookingPaymentThemeOverrides = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        textTransform: 'none' as const,
        fontWeight: 600,
      },
    },
  },
  MuiTypography: {
    styleOverrides: {
      root: {
        fontFamily: '"Inter", "Roboto", "Arial", sans-serif',
      },
    },
  },
};
export const paymentLinkViewStyles: Record<string, SxProps> = {
  textstyle: {
    fontFamily: Font.Lexend,
    fontWeight: 600,
    color: Color.Grey500,
    fontSize: '24px',
    lineHeight: '36px',
    letterSpacing: '-0.18px',
    fontStyle: 'normal',
    marginBottom: 1,
  },
  successTextstyle: {
    fontFamily: Font.Lexend,
    fontWeight: 600,
    color: Color.SuccessMain,
    fontSize: '24px',
    lineHeight: '36px',
    letterSpacing: '-0.18px',
    fontStyle: 'normal',
    marginBottom: 1,
  },
  errorTextstyle: {
    fontFamily: Font.Lexend,
    fontWeight: 600,
    color: Color.ErrorMain,
    fontSize: '24px',
    lineHeight: '36px',
    letterSpacing: '-0.18px',
    fontStyle: 'normal',
    marginBottom: 1,
  },
  subTextStyle: {
    fontFamily: Font.Lexend,
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '22px',
    letterSpacing: '-0.12px',
    fontStyle: 'normal',
    color: Color.TextPrimary,
    marginBottom: 2,
  },
  successSubTextStyle: {
    fontFamily: Font.Lexend,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    letterSpacing: '-0.12px',
    fontStyle: 'normal',
    color: Color.SuccessMain,
    marginBottom: 2,
  },
  successIconContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    mb: 2,
  },
};
